module.exports = __webpack_public_path__ + "static/media/bardo-large.012d1b42.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bardo-large.svg
// module id = 2535
// module chunks = 0